import React, { FC } from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { COMMENT_GENERATION_LANGUAGES } from '../../constants/commentGenerationLanguages';

interface Props {
  language: string;
  setLanguage: (l: any) => void;
}

const LanguageControl: FC<Props> = ({ language, setLanguage }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <FormControl
      size="small"
      fullWidth
      sx={{ width: 200, mr: theme.spacing(1) }}
    >
      <InputLabel id="language-label">{t('language')}</InputLabel>
      <Select
        labelId="language-label"
        label={t('language')}
        value={language}
        onChange={(e: SelectChangeEvent) => {
          setLanguage(e.target.value);
        }}
      >
        {COMMENT_GENERATION_LANGUAGES.map(({ value, labelKey }) => (
          <MenuItem
            key={value}
            value={value}
          >
            {t(labelKey)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageControl;
